module.exports = __webpack_public_path__ + "img/dd-logo-chevy.a88ce6d1.png";